<template>
  <LpInput
    name="Search"
    :model-value="modelValue"
    :placeholder="searchPlaceholder"
    autocomplete="off"
    @update:model-value="onUpdate"
  >
    <template #icon>
      <MagnifierIcon class="w-5 h-5" />
    </template>
  </LpInput>
</template>

<script>
import { MagnifierIcon } from '@thehotelsnetwork/icons/vue/linear';

export default {
  components: {
    MagnifierIcon,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    searchPlaceholder: {
      type: String,
      default: 'Search...',
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const onUpdate = (val) => {
      emit('update:modelValue', val);
    };

    return {
      onUpdate,
    };
  },
};
</script>
